/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('product:added', function(event) {
    if (window.dataLayer) {
      var sku = '';
      var quantity = event.detail.quantity;
      if (event.detail.variant?.sku) {
         sku = event.detail.variant.sku
      }

      window.dataLayer.push({
        event: 'cuyana_atb',
        variant: sku,
        quantity: quantity
      });
    }

    if ((event.detail.source === 'configurator' || event.detail.source === 'bundlinator' || event.detail.source === 'cuy-drawer') && window.dataLayer) {
      window.dataLayer.push({
        event: 'cuyana_configurator_atb',
        source: event.detail.source,
        quantity: event.detail.quantity,
        products: event.detail.products
      });
    }
});

// Track clicks on all three "Customize" button variants.
// Covers both the PDP form buttons and sticky-drawer clones (same classes).
document.addEventListener('click', function(event) {
  var btn = event.target.closest(
    'button.ProductForm__Configurator, button.ProductForm__Bundlinator, button.ProductForm__CuyDrawer'
  );
  if (btn && window.dataLayer) {
    var source = btn.classList.contains('ProductForm__Configurator') ? 'configurator'
               : btn.classList.contains('ProductForm__Bundlinator')  ? 'bundlinator'
               : 'cuy-drawer';
    window.dataLayer.push({
      event: 'cuyana_customize_btn_click',
      source: source
    });
  }
});